export default __webpack_public_path__ + "static/media/004-camper van.7831cfff.svg";